import { Grid, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import globals from "../globals";

const Countdown = ({ targetDate }) => {
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000); // update every second

        return () => clearInterval(timer); // cleanup
    }, [targetDate]);

    // helper for zero-padding
    const format = (num) => String(num).padStart(2, "0");

    return ( 
        <>
            {timeLeft.days} д. {format(timeLeft.hours)} ч. {format(timeLeft.minutes)} мин. {format(timeLeft.seconds)} сек.
        </>
    );
}

export default Countdown